// Staging Url
export const API_URL = "https://wca-backend.orientaloutsourcing.in";

// Live URL
// export const API_URL = "http://localhost:5000"
